module.exports = __webpack_public_path__ + "img/19.c89848c4.jpg";